var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$attrs.to === null || _vm.$route.query._storyblok)?_c('span',[_vm._t("default")],2):(/^(http[s]?|mailto):/.test(_vm.to))?_c('a',{attrs:{"href":_vm.to,"data-type":"a"}},[_vm._t("default")],2):_c('nuxt-link',_vm._b({},'nuxt-link',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }